module.exports = __webpack_public_path__ + "img/lagerausbildung-4bohrungen_zzz.995bde78.jpg";